import React from 'react';
import LinksList from '../helpers/links/LinksList';

export default function AppHeaderLinks() {


    const linksArr = [
        { domName: "Home", routeName: "HOME" },
        { domName: "Careers", routeName: "CAREERS" },
    ];

    return (
        <div className="flex items-center">
            <LinksList linksArr={linksArr} />
        </div>
    );
}
